<template>
  <div style="background-color: #f4fbff">
    <Header @onRefreshClick="onRefresh"> </Header>
    <van-tabs
      v-model:active="active"
      @click-tab="clickTab"
      type="card"
      title-active-color="black"
      title-inactive-color="black"
      background="#f5f5f5"
      :animated="true"
      color="#fff"
      style="margin-top: 20px; font-size: 10px; "
    >
      <van-tab title="通話履歴" name='log' >
        <van-list
          v-model:loading="loadingList"
          :finished="finished"
          finished-text="これ以上データがありません"
          @load="onLoad"
        >
          <div class="home home-user tel">
            <div class="home_notice-search tel-search">
              <form>
                <input
                  v-model="this.search.name"
                  type="search"
                  name="searchInput"
                  placeholder="検索"
                  @search="clearSearch('callLog')"
                />
                <input
                  type="submit"
                  onclick="return false;"
                  name="submit"
                  value="検索"
                  @click="searchByName"
                />
              </form>
            </div>

            <div class="home_past-notice tel_list">
              <div class="tel_list-inner">
                <div
                  class="tel-item"
                  v-for="item in noticeList"
                  :key="item"
                  @click="getMemberDetail(item)"
                >
                  <div class="tel-info">
                    <p class="tel-name">
                      {{ item.name }}
                      <span
                        class="tel-name_situation made"
                        v-show="item.call_type == 2 && item.call_answer_at"
                        >発信</span
                      >
                      <span
                        class="tel-name_situation received"
                        v-show="item.call_type == 1 && item.call_answer_at"
                        >着信</span
                      >
                      <span
                        class="tel-name_situation missed"
                        style="width: 70px"
                        v-show="item.call_type == 1 && !item.call_answer_at"
                        >不在着信</span
                      >
                      <span
                        class="tel-name_situation missed_send"
                        style="width: 70px"
                        v-show="item.call_type == 2 && !item.call_answer_at"
                        >不在発信</span
                      >
                    </p>
                    <p class="call-time" v-show="item.call_answer_at">
                      通話時間 :
                      {{ getTimeDiff(item.call_answer_at, item.call_end_at) }}
                    </p>
                    <p class="call-time" v-show="!item.call_answer_at && item.type != 'roomLog'">
                      通話時間 : 0
                    </p>
                    <!-- 进出room记录 -->
                    <p class="call-time" v-show="item.type == 'roomLog'">
                      入室時間：
                      {{ formatDate(item.call_start_at) }}
                    </p><p class="call-time" v-show="item.type == 'roomLog'">
                      退室時間：
                      {{ formatDate(item.call_end_at) }}
                    </p>
                  </div>
                  <p class="tel-date">
                    <span class="item-day">{{ item.callDate }}</span>
                    <span class="item-time">{{ item.callTime }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>

      <van-tab title="個別通話" name='list' >
        <div class="home home-user">
          <div class="home_notice-search">
            <form>
              <input
                v-model="this.searchIndividual.name"
                type="search"
                name="searchInput"
                placeholder="ユーザーまたはチームを検索"
                @search="clearSearch('individual')"
              />
              <input
                type="submit"
                onclick="return false;"
                name="submit"
                value="検索"
                @click="searchByIndividualName"
              />
            </form>
            <div class="search-btn search-btn_user" @click="showSearch">
              <span>並び替え</span>
            </div>
          </div>


          <div
            class="home_past-notice home_user-team" v-for="item in memberList" :key="item.id">
            <p class="title-days title-team-name" @click="openList(item)" :class="[item.showAll ? '' : 'open']">
              {{ item.team_name }}(オンライン{{item.onlineCount }}名　オフライン{{ item.offlineCount }}名)
            </p>
            <div class="team-block" :style="{ display: item.showAll ? 'block' : 'none' }">
              <div class="user-item" v-for="(member_list, index) in item.member_list.sort((a, b) => {
              if (this.sortOption === 'phonetic') {
                return a.name.localeCompare(b.name, 'ja');
              } else {
                return 0;
              }
            })"
            :key="index" @click="getMemberDetail(member_list)">
                <!-- <p class="user-name" :style="{ opacity: member_list.online_status == 'online' ? '1' : '0.5' }">
                  {{ member_list.name }}
                  <span class="online" v-if="member_list.online_status == 'online'"></span>
                </p> -->
                <p class="user-name" :style="{ color: member_list.online_status !== 'online' ? '#D9D9D9' : 'inherit' }">
                  <span>{{ member_list.name }}</span>
                  <span class="online" v-if="member_list.online_status == 'online'"></span>
                </p>

                <span class="user-staff" v-show="member_list.type != 'patient'">スタッフ</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="ルーム通話" name='room' >
        <div class="home home-user tel">
          <div class="home_notice-search tel-search tel-room-add">
            <form>
              <input
                v-model="this.searchRoom.name"
                type="search"
                name="searchInput"
                placeholder="部屋を検索"
                @search="clearSearch('room')"
              />
              <input
                type="submit"
                onclick="return false;"
                name="submit"
                value="検索"
                @click="initRoomList"
              />
            </form>
          </div>
          <div
            style="
              display: flex; justify-content: flex-end; align-items: center; margin-bottom: 5%;
            "
          >
            <div class="room-btn" @click="roomCreateShow" style="margin-left: 10%; margin-right: 4%;">
              <span>部屋を作成</span>
            </div>
            <div class="room-btn" @click="openTicketJoin" style="margin-right: 5%;">
              <span>コードを入力</span>
            </div>
          </div>

          <div class="home_past-notice tel_list">
            <div class="tel-group_list-inner">
              <div
                class="tel-group-item rock"
                v-for="(item, index) in roomList"
                :key="index"
              >
                <div>
                  <span class="tel-group-mode vacant" v-show="item.status != 1"
                    >空室</span
                  >
                  <span class="tel-group-mode" v-show="item.status == 1"
                    >通話中</span
                  >
                  <p class="tel-group-name">{{ item.name }}</p>
                </div>
                <div class="tel-group-right">
<!--                  <van-icon-->
<!--                    size="30"-->
<!--                    name="setting-o"-->
<!--                    style="margin-right: 10px"-->
<!--                    @click="openSetting(item)"-->
<!--                  />-->
                  <div
                    class="tel-group-date room-out"
                    v-if="item.status == 1"
                    @click="onStart(item)"
                  >
                    参加する
                  </div>
                  <div
                    class="tel-group-date room-out"
                    style="background-color: #3B82C4; border: 2px solid #3B82C4"
                    v-if="item.status != 1"
                    @click="onStart(item)"
                  >
                    入室する
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <van-dialog
        v-model:show="searchModalShow"
        title="並び替え"
        @confirm="searchList"
    >
      <div id="search-modal ">
        <div class="search-modal_inner">
          <div class="search-modal_list">
            <input
                type="radio"
                name="select"
                value="all"
                checked="true"
                id="all"
            />
            <label for="all" class="radio">すべて</label>
            <input type="radio" name="select" value="patient" id="user" />
            <label for="user" class="radio">利用者</label>
            <input type="radio" name="select" value="doctor" id="staff" />
            <label for="staff" class="radio">スタッフ</label>

            <p class="search-modal_title-sub">詳細設定</p>
            <input id="abc" type="checkbox" name="check" />
            <label for="abc" class="checkbox">あいうえお順</label>
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog
      v-model:show="showRoomSetting"
      title="チケット発行"
      :showConfirmButton="false"
    >
      <button class="close" type="button">
          <img
            src="../../assets/img/home/close.png"
            alt="閉じる"
            @click="closeSetting"
          />
      </button>
      <div>
        <van-cell-group inset style="margin-top: 15px">
          <van-field
            v-model="roomInfo.name"
            center
            clearable
            label="部屋名:"
            readonly
            input-align="right"
          >
          </van-field>
          <van-field
            v-model="roomInfo.check_code"
            center
            clearable
            label="チケット:"
            maxlength="6"
            readonly
            input-align="right"
          >
          </van-field>
          <van-field
            v-model="roomInfo.check_time"
            center
            clearable
            label="有効期間:"
            readonly
            input-align="right"
          >
          </van-field>
          <div style="width: 100%; margin-top: 10px; margin-bottom:20px; text-align: center">
            <van-button class="ticket-btn"
              v-if="!roomInfo.check_code"
              @click="updateCheckCode"
              >発行</van-button
            >
            <van-button class="ticket-btn"
              v-else
              @click="updateCheckCode"
              >もう一度発行</van-button
            >
          </div>
        </van-cell-group>
      </div>
    </van-dialog>

    <van-dialog v-model:show="showRoomCreate" :showConfirmButton="false">
      <div class="search-modal_inner">
        <button class="close" type="button">
          <img
            src="../../assets/img/home/close.png"
            alt="閉じる"
            @click="closeRoomCreate"
          />
        </button>
        <p class="search-modal_title">部屋を作成</p>
        <div class="search-modal_list">
          <p class="search-modal_title-sub">部屋名</p>
          <input
            type="text"
            name="room-name"
            placeholder="部屋名を入力"
            class="room-name"
            v-model="this.roomInfo.name"
          />
          <div class="mypage_switching-item tel-swich-item">
            <p class="mypage_switching-name">入室制限</p>
            <van-switch v-model="checked" active-color="#3B82C4" />
          </div>
          <p class="search-modal_title-sub" v-show="checked">一般ユーザ:</p>
          <input v-show="checked"
            readonly
            clickable
            type="text"
            name="room-name"
            placeholder="選択してください"
            class="room-name"
            v-model="chooseName"
            @click="showChoose"
          />
        </div>

        <van-button
          :disabled="!this.roomInfo.name || !this.chooseName"
          block
          :color="!this.roomInfo.name || !this.chooseName ? '#AACBE7' : '#48b2fb'"
          type="primary"
          native-type="submit"
          :loading="loading"
          @click="onClickAddRoom"
          class="tel-add-room_btn"
          >作成する</van-button
        >
      </div>
    </van-dialog>

    <van-dialog
        v-model:show="refreshModelShow"
        :closeOnClickOverlay="true"
        :showConfirmButton="true"
        :showCancelButton="true"
        @confirm="refreshPatient"
    >
      <div id="tel-popup active">
        <div class="tel-popup_inner">
          <p class="tel-popup_row">
            <span class="tel-popup_name">{{ chooseItem.name }}</span>
          </p>
          <div>
            リフレッシュをします。よろしいですか？
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog
      v-model:show="callModalShow"
      :closeOnClickOverlay="true"
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <div id="tel-popup active">
        <div class="tel-popup_inner">
          <p class="tel-popup_row">
            <span class="tel-popup_name">{{ chooseItem.name }}</span>
          </p>
          <div class="tel-popup_row tel-popup_btn-area">
            <div class="tel-popup_btn-area-div">
              <div class="tel-popup_btn voice" @click="call('audio')">
                音声通話
              </div>
              <div class="tel-popup_btn video" @click="call('video')">
                ビデオ通話
              </div>
              <div class="tel-popup_btn chat" @click="toChat">チャット</div>
            </div>
            <div class="tel-popup_btn-area-div tel-popup_btn-area-div-bottom" v-show="chooseItem.type == 'patient'" @click="showRefreshModel()">
              リフレッシュ
            </div>
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model:show="ticketJoinModalShow" :showConfirmButton="false">
      <div style="padding-top: 10px">
        <h3 style="text-align: center; margin-bottom: 18px; margin-top: 18px">
          チケット入室
        </h3>
        <button class="close" type="button">
          <img
            src="../../assets/img/home/close.png"
            alt="閉じる"
            @click="closeTicketJoin"
          />
        </button>
        <van-cell-group inset>
          <van-field
            v-model="roomCode"
            center
            clearable
            label="チケット："
            maxlength="6"
            input-align="right"
          >
          </van-field>
          <h2 style="text-align: center; margin-bottom: 18px; margin-top: 18px" v-show="yoteiRoomList && yoteiRoomList.length>0">
            複数の会議が存在します
          </h2>
          <van-radio-group v-model="chooseYoteiRoom">
            <van-radio style="padding: 5px 0" icon-size="24px"
              v-for="item in yoteiRoomList" :key="item.roomyotei_id" :name="item.roomyotei_id">
              {{item.yotei_name}}
            </van-radio>
          </van-radio-group>
        </van-cell-group>

        <div style="text-align: center; margin-top: 15px; margin-bottom: 20px">
          <van-button class="ticket-btn"
            style="width:80%"
            @click="joinRoom"
            >入室</van-button
          >
        </div>
      </div>
    </van-dialog>

    <div v-if="showType" class="popup-bg">
      <div class="popup">
        <div class="btn">
          <div @click="cancel" class="cancle">キャンセル</div>
          <div @click="confirm" class="confirm">確認</div>
        </div>
        <van-cell clickable title="すべて選択" @click="selectAll()">
          <template #right-icon>
            <van-checkbox
                shape="square"
                v-model="selectAllFlg"
                @click.stop="selectAll(true)"
            />
          </template>
        </van-cell>
        <van-cell
            v-for="(item, index) in doctorColums"
            clickable
            :key="index"
            :title="item.name"
            @click="selectItem(item)"
        >
          <template #right-icon>
            <van-checkbox
                shape="square"
                v-model="item.selected"
                @click.stop="selectItem(item,true)"
            />
          </template>
        </van-cell>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import { GetMyLogList } from "@/services/log";
import { GetRoomDetail, GetRoomList, RoomYoteiCheck, UpdateCheckCode} from "@/services/room.js";
import {FindTeamMembers, FindSameTeamDoctors,} from "@/services/team";
import { RefreshUserInfo } from "@/services/login";
import { Toast } from "vant";
import "vant/es/toast/style";
import { SaveRoom } from "@/services/room";
import moment from 'moment';
import _ from 'lodash';
import {refreshApp} from "@/services/user";


export default {
  data() {
    return {
      ticketJoinModalShow: false,
      chooseItem: {
        id: "",
        name: "",
        type: "",
      },
      noticeList: [],
      active: "log",
      show: false,
      list: [],
      loading: false,
      loadingList: false,
      currentPage: 0,
      pageSize: 15,
      finished: false,
      showAddRoom: false,
      showRoomSetting: false,
      check_code: "",
      roomCode: "",
      roomIdList: [],
      roomList: [
        {
          join_list: [],
        },
      ],
      roomInfo: {},
      firstRoomList: [],
      showRoomInfo: false,
      joinRoomTime: null,
      showRoomCreate: false,
      checked: false,
      ticketNum: 1,
      showType: false,
      doctorColums: [],
      chooseName: "",
      chooseId: [],
      backChoose:[],
      selectAllFlg:false,
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      timer: null,
      search: {
        type: "all",
        name: "",
      },
      searchIndividual: {
        type: "all",
        name: "",
      },
      searchRoom: {
        type: "all",
        name: "",
      },
      memberList: [],
      doctorList: [],
      searchModalShow: false,
      callModalShow: false,
      userInfo: null,
      memberListInterval:null,
      // 预约会议用
      yoteiRoomList:null,
      chooseYoteiRoom:null,

      refreshModelShow: false,
    };
  },
  components: {
    Footer,
    Header,
  },
  mounted() {
    // tab初始化显示
    this.active= sessionStorage.getItem("tsunagaru_team_list_tab") || "log";
    console.log(this.active);
    this.roomList = [];
    this.roomIdList = [];
    this.initRoomList();

    this.initMemberList();
    this.memberListInterval = setInterval(() => {
      //每秒更新一次时间
      this.initMemberList();
    }, 5000);
  },
  beforeUnmount(){
    if(this.memberListInterval){
      clearInterval(this.memberListInterval);
    }
  },
  methods: {
    showRefreshModel() {
      this.refreshModelShow = true;
    },
    async refreshPatient() {
      const res = await refreshApp({account_ids:[this.chooseItem.id]});
      if(res.data.code >= 0){
        Toast.success("リフレッシュ成功");
      }else{
        Toast.fail("リフレッシュ失敗");
      }
    },
    clickTab(){
      sessionStorage.setItem("tsunagaru_team_list_tab",this.active);
    },
    onLoad() {
      // 异步更新数据
      this.loadingList = true;
      this.currentPage++;
      GetMyLogList({
        page: this.currentPage,
        pageSize: this.pageSize,
        search: this.search,
      }).then((res) => {
        this.noticeList = this.noticeList.concat(res.data.data.list);
        // 加载状态结束
        this.loadingList = false;
        if (res.data.data.list && res.data.data.list.length <= 0) {
          this.finished = true;
        }
      });
    },
    getTimeDiff(startTime, endTime) {
      let startTimeFmt = startTime
      let endTimeFmt = endTime

      if(startTime && startTime!==""){
        startTimeFmt = startTime.replace(' ', 'T');
      }

      if(endTime && endTime!==""){
        endTimeFmt = endTime.replace(' ', 'T');
      }

      let start = new Date(startTimeFmt).getTime();
      let end = new Date(endTimeFmt).getTime();
      let diff = end - start;
      let hours = Math.floor(diff / (3600 * 1000));
      let minutes = Math.floor(diff / (60 * 1000)) % 60;
      let seconds = Math.floor(diff / 1000) % 60;
      let result = "0";
      if (hours > 0) {
        result = hours + "時";
      }
      if (minutes > 0) {
        result = minutes + "分";
      }
      if (seconds > 0) {
        result = seconds + "秒";
      }
      return result;
    },
    openTicketJoin(){
      this.ticketJoinModalShow = true;
      this.roomCode = "";
      this.yoteiRoomList = null;
      this.chooseYoteiRoom = null;
    },
    closeTicketJoin() {
      this.ticketJoinModalShow = false;
      this.roomCode = "";
      this.yoteiRoomList = null;
      this.chooseYoteiRoom = null;
    },
    getMemberDetail(item) {
      this.chooseItem = item;
      console.log(this.chooseItem);
      if (item.type && item.type != "roomLog") {
        this.callModalShow = true;
      }
    },
    call(type) {
      if(type != 'audio') {
        this.$router.push({
          path: "/beforeCall",
          query: {type:this.chooseItem.type,chooseItem_id:this.chooseItem.id},
        });
        return
      }
      this.callModalShow = false;
      this.$emit('callUser',type,this.chooseItem);
    },
    toChat() {
      if (this.chooseItem && this.chooseItem.type == "doctor") {
        this.$router.push({
          path: "/chatDetail",
          query: {
            doctor_id: this.chooseItem.id,
            doctor_name: this.chooseItem.name,
          },
        });
      } else {
        RefreshUserInfo().then((res) => {
          if (res.data.data.user.auth_list.includes("notice")) {
            this.$router.push({
              path: "/chatToPatient",
              query: {
                patient_id: this.chooseItem.id,
                patient_name: this.chooseItem.name,
              },
            });
          } else {
            Toast.fail("権限がありません");
          }
        });
      }
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
      this.initNoticeList();
      this.initRoomList();
    },
    initNoticeList() {
      GetMyLogList({
        page: this.currentPage,
        pageSize: this.pageSize,
        search: this.search,
      }).then((res) => {
        this.noticeList = res.data.data.list;
      });
    },
    onClickLeft() {
      history.back();
    },
    changeRefreshStatus(status) {
      //设置页面刷新与否
      this.$store.commit("changeRefreshStatus", status);
    },
    async joinRoom() {
      const res = await RoomYoteiCheck({
        ticket:this.roomCode
      });
      if(res.data.code >= 0){
        const data = res.data.data;
        if(data.room_list.length > 1){
          this.yoteiRoomList = data.room_list;
          if(this.chooseYoteiRoom){
            const find = this.yoteiRoomList.find((item) => item.roomyotei_id == this.chooseYoteiRoom);
            if (find) {
              this.$router.push({
                path: "/beforeRoom",
                query: { id: find.roomId, room_id: find.room_id ,yotei_id:find.roomyotei_id,ticket:this.roomCode},
              });
            }else{
              this.chooseYoteiRoom = null;
              Toast.fail("タイムアウトしました。再度選択してください");
            }
          }
        }else if(data.room_list.length == 1){
          this.$router.push({
            path: "/beforeRoom",
            query: { id: data.room_list[0].id, room_id: data.room_list[0].room_id ,ticket:this.roomCode},
          });
        }else{
          Toast.fail('対応する会議が見つかりません。');
        }

      }else{
        Toast("error");
      }
    },
    updateCheckCode() {
      const id = this.roomInfo.id;
      UpdateCheckCode(id).then(() => {
        GetRoomDetail(this.roomInfo.room_id).then((res) => {
          this.roomInfo = res.data.data.detail;
          this.showRoomSetting = true;
        });
      });
    },
    openSetting(item) {
      this.showAddRoom = false;
      if (item && item.room_id) {
        const room_id = item.room_id;
        GetRoomDetail(room_id).then((res) => {
          this.roomInfo = res.data.data.detail;
          this.showRoomSetting = true;
          this.changeRefreshStatus(false);
        });
      }
    },
    closeSetting(){
      this.showRoomSetting = false;
    },
    openAdd() {
      this.roomCode = "";
      this.showAddRoom = true;
      this.showRoomSetting = false;
      this.changeRefreshStatus(false);
    },
    initRoomList() {
      this.roomList = [];
      this.roomIdList = [];

      GetRoomList({ search: this.searchRoom }).then((res) => {
        if (res.data.data) {
          this.roomList = res.data.data;
          this.roomList.forEach((item) => {
            this.roomIdList.push(item.room_id);
            if (
              item.all_doctor != "1" &&
              item.member_ids &&
              item.member_ids != ""
            ) {
              let join_str = item.member_ids;
              let join_arr = join_str.split(",");
              item.join_list = join_arr;
            } else {
              item.join_list = [];
            }
          });
          //status: callind,wait
          //当前参与用户列表: current_ids
        }
      });
    },
    onStart(item) {
      const leaveRoomTime = this.$store.state.leaveRoomTime;
      const nowDate = new Date();
      const diffHangUp = Math.floor((nowDate - leaveRoomTime) / 1000);
      if (diffHangUp < 2) {
        Toast.loading({
          message: "",
          forbidClick: true,
          duration: 2000,
        });
        setTimeout(() => {
          this.toRoom(item);
        }, 2000);
      } else {
        this.toRoom(item);
      }
    },
    toRoom(item) {
      if (item && item.room_id) {
        const room_id = item.room_id;
        GetRoomDetail(room_id).then((res) => {
          let roomInfo = res.data.data.detail;
          if (roomInfo) {
            this.$router.push({
              path: "/beforeRoom",
              query: { id: roomInfo.id, room_id: roomInfo.room_id },
            });
          }
        });
      }
    },
    roomCreateShow() {
      this.showRoomCreate = true;
      this.roomInfo = {};
      this.initDoctorList();
      this.checked = false;
    },
    closeRoomCreate() {
      this.roomInfo = {};
      this.showRoomCreate = false;
    },
    subtractTicket() {
      this.ticketNum--;
    },
    addTicket() {
      this.ticketNum++;
    },
    onClickAddRoom() {
      const detail = {
        name: this.roomInfo.name,
        type: "app",
      };
      if(this.checked){
        detail.all_doctor = 0;
        // 非全员入室 必须选择自身
        if (!this.chooseId.includes(this.user.login_account_id)) {
          Toast.fail("ご自身を選択してください。");
        }
      }else{
        detail.all_doctor = 1;
      }
      detail.join_doctor_ids = this.chooseId.join(',');
      SaveRoom({
        detail: detail,
      }).then((res) => {
        if (res.data.code >= 0) {
          Toast.success("追加に成功しました。");
          this.closeRoomCreate();
          this.initRoomList();
        } else {
          Toast.fail("追加に失敗しました。");
        }
      });
    },
    initDoctorList() {
      FindSameTeamDoctors().then((res) => {
        this.doctorColums = res.data.data || [];
        // 默认选中自己
        for(let i=0;i<this.doctorColums.length;i++){
          if(this.doctorColums[i].doctor_id == this.user.login_account_id){
            this.doctorColums[i].selected = true;
            break;
          }
        }
        this.setChooseName();
      });
    },
    selectAll(isCheckBox){
      if(!isCheckBox){
        this.selectAllFlg = !this.selectAllFlg;
      }
      this.doctorColums.forEach((item)=>{
        item.selected = this.selectAllFlg;
      });
    },
    selectItem(item,isCheckBox){
      if(!isCheckBox){
        item.selected = !item.selected;
      }
      this.setChooseName();
    },
    setChooseName(){
      let chooseName = "";
      let chooseId = [];
      let selectAllFlg = true;
      this.doctorColums.forEach((item)=>{
        if(item.selected && chooseName ==''){
          chooseName = item.name;
          chooseId.push(item.doctor_id)
        }else if(item.selected && chooseName !==''){
          chooseName += ","+ item.name;
          chooseId.push(item.doctor_id)
        }else{
          selectAllFlg = false;
        }
      });
      this.chooseName = chooseName;
      this.chooseId = chooseId;
      this.selectAllFlg = selectAllFlg;
    },
    showChoose() {
      this.showType = true;
      // 深拷贝
      this.backChoose = _.cloneDeep(this.doctorColums);
    },
    confirm() {
      this.showType = false;
      this.setChooseName();
    },
    cancel() {
      this.showType = false;
      this.doctorColums = _.cloneDeep(this.backChoose);
    },
    closeRoomInfo() {
      this.showRoomInfo = false;
      this.roomCode = "";
    },
    searchByName() {
      this.currentPage = 0;
      this.finished = false;
      this.initNoticeList();
    },
    searchByIndividualName() {
      this.initMemberList();
    },
    searchList() {
      sessionStorage.removeItem("tsunagaru_team_list_close")
      this.searchIndividual.type = JQuery("input[type='radio']:checked").val();
      if (document.getElementById("abc").checked) {
        this.sortOption = "phonetic";
      } else {
        this.sortOption = "default";
      }
      this.initMemberList();
    },
    initMemberList() {
      FindTeamMembers({ search: this.searchIndividual }).then((res) => {
        this.memberList = res.data.data;
        if (this.memberList && this.memberList.length > 0) {
          this.memberList.forEach((item) => {
            let close_list_str = sessionStorage.getItem("tsunagaru_team_list_close") || "";
            let close_list = close_list_str ? close_list_str.split(',') : [];
            if (close_list.includes(item.team_id)) {
              item.showAll = false;
            }else{
              item.showAll = true;
            }
            const onlineMembers = item.member_list.filter(function (member) {
              return member.online_status == "online";
            });
            item.onlineCount = onlineMembers.length;
            item.offlineCount = item.member_list.length - onlineMembers.length;
          });
        }
      });
    },
    openList(item) {
      item.showAll = !item.showAll;
      let close_list_str = sessionStorage.getItem("tsunagaru_team_list_close") || "";
      let close_list = close_list_str ? close_list_str.split(',') : [];
      if(item.showAll){
        close_list = close_list.filter(close_item => close_item !== item.team_id);
      }else{
        if (!close_list.includes(item.team_id)) {
          close_list.push(item.team_id);
        }
      }
      sessionStorage.setItem("tsunagaru_team_list_close",close_list.join(','));
    },
    showSearch() {
      this.searchModalShow = true;
    },
    clearSearch(type) {
      if (type === "callLog") {
        this.initNoticeList();
      } else if (type === "individual") {
        this.initMemberList();
      } else {
        this.initRoomList();
      }
    },
    formatDate(timestamp) {
      return moment(timestamp).format('HH:mm:ss');
    },
  },
  watch: {},
  computed: {},
};
</script>

<style scoped>
.van-tab--active .van-tab__text {
  font-size: 13px;
  font-weight: 700;
}
.van-tab__text {
  font-size: 13px;
}
.van-tab--active {
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.12), 0px 3px 1px rgba(0, 0, 0, 0.04);
  border-radius: 6.93px;
}
.van-tabs__nav--card {
  border-radius: 6.93px !important;
}
.tel-group-right {
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-bg {
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
}
.btn {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 999;
  background-color: white;
}
.cancle {
  padding: 15px 0px 15px 18px;
  font-size: 18px;
  font-weight: bold;
}
.confirm {
  padding: 15px 18px 15px 0px;
  font-size: 18px;
  font-weight: bold;
}
.popup {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 400px;
  overflow: auto;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: #fff;
}
.room-info {
  text-align: center;
  background-color: white;
  border-radius: 10px;
  margin-bottom: 10px;
}
.ticket-btn {
  background-color:#3B82C4;
  font-style: normal;
  /* font-weight: 700; */
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: center;
  /* IS/Text_white */
  color: #FFFFFF;
  width: 90%;
  border-radius: 8px;

}
.room-btn {
  height: 35px;
  width: 100px;
  display: flex; 
  justify-content: center; 
  align-items: center;
}
</style>
